// extracted by mini-css-extract-plugin
module.exports = {"ratingStarsContainer":"StarsRating_ratingStarsContainer__TEfFm"};